import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Pipe personalizzata per la valuta che mostra il simbolo € prima del prezzo
 * solo per la lingua olandese (nl), altrimenti usa il comportamento standard
 */
@Pipe({
  name: 'localizedCurrency',
  pure: false // per ricaricare la traduzione al cambio di lingua
})
export class LocalizedCurrencyPipe implements PipeTransform {

  constructor(
    private translateService: TranslateService,
    private currencyPipe: CurrencyPipe
  ) {}

  public transform(value: number | string, currencyCode: string = 'EUR', display: string = 'symbol'): string | null {
    const currentLang = this.translateService.currentLang;
    // Per la lingua olandese, mostra il simbolo € prima del prezzo
    if (currentLang === 'nl' && currencyCode === 'EUR') {
      const formattedValue = this.currencyPipe.transform(value, currencyCode, display, '1.2-2', 'nl-NL');
      if (formattedValue) {
        // Rimuove il simbolo dalla fine e lo mette all'inizio
        const cleanValue = formattedValue.replace(/€\s*/, '').trim(); 
        return `€ ${cleanValue}`;
      }
    }
    
    // Per tutte le altre lingue, usa il comportamento standard
    return this.currencyPipe.transform(value, currencyCode, display, '1.2-2', currentLang);
  }
}